import { globals } from '../utils';
import cleanDeeplink from '../utils/cleanDeeplink';
import { reportFlexEvent } from './reportFlexEvent';
function mark(name) {
    var _a, _b, _c, _d;
    (_d = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.performance) === null || _b === void 0 ? void 0 : (_c = _b).mark) === null || _d === void 0 ? void 0 : _d.call(_c, name);
}
function getEntriesByName(name) {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.performance) === null || _b === void 0 ? void 0 : (_c = _b).getEntriesByName) === null || _d === void 0 ? void 0 : _d.call(_c, name);
}
function measure(name, startMark, endMark) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (((_d = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.performance) === null || _b === void 0 ? void 0 : (_c = _b).getEntriesByName) === null || _d === void 0 ? void 0 : _d.call(_c, startMark).length) > 0) {
        if (endMark) {
            (_h = (_f = (_e = globals) === null || _e === void 0 ? void 0 : _e.performance) === null || _f === void 0 ? void 0 : (_g = _f).measure) === null || _h === void 0 ? void 0 : _h.call(_g, name, startMark, endMark);
        }
        else {
            (_m = (_k = (_j = globals) === null || _j === void 0 ? void 0 : _j.performance) === null || _k === void 0 ? void 0 : (_l = _k).measure) === null || _m === void 0 ? void 0 : _m.call(_l, name, startMark);
        }
    }
}
function hasMark(name) {
    var _a, _b, _c, _d;
    if (!globals.performance) {
        return false;
    }
    else {
        return ((_d = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.performance) === null || _b === void 0 ? void 0 : (_c = _b).getEntriesByName) === null || _d === void 0 ? void 0 : _d.call(_c, name).length) > 0;
    }
}
function clearMarks(name) {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.performance) === null || _b === void 0 ? void 0 : (_c = _b).clearMarks) === null || _d === void 0 ? void 0 : _d.call(_c, name);
}
function clearMeasures(name) {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.performance) === null || _b === void 0 ? void 0 : (_c = _b).clearMeasures) === null || _d === void 0 ? void 0 : _d.call(_c, name);
}
async function reportPageLatency(entries, deeplink, auth) {
    const { UAParser } = await import(/* webpackChunkName: "metrics" */ 'ua-parser-js');
    const ua = new UAParser(globals.navigator.userAgent);
    return reportFlexEvent(`WebPlayerPageLatency`, [
        [cleanDeeplink(deeplink), ua.getOS().name, ua.getBrowser().name, ua.getBrowser().major],
        [entries.page.duration, entries.render.duration, entries.request.duration]
    ], auth);
}
export default {
    mark,
    measure,
    hasMark,
    getEntriesByName,
    clearMeasures,
    clearMarks,
    reportPageLatency,
};
